import { Category } from '../types/blogPost'
import TableOfContents from './TableOfContents'
import SimilarArticles from './similar-articles'
import Sidebar from './Sidebar'

interface SidebarProps {
  category?: Category
}

function BlogSidebar({ category }: SidebarProps) {
  return (
    <Sidebar>
      {category && <SimilarArticles />}
      <TableOfContents />
    </Sidebar>
  )
}

BlogSidebar.defaultProps = {
  publishedAt: undefined,
  updatedOn: undefined,
  category: undefined,
}

export default BlogSidebar
